import {lazy, Suspense, useEffect} from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {useAppContext} from './context/AppContext';
import SpinnerComponent from './components/spinner/spinnerComponent';
import {ERROR_ROUTE, TAX_CONFIGURATION_ROUTE, NO_ACCOUNT_ROUTE, ONBOARDING_ROUTE, SHOPIFY_UI_ROUTE} from './constants/constants';
import styles from './App.module.scss';//import styles

const OnBoarding = lazy(() => import('./pages/onBoarding/onBoarding'));//import onBoarding Page
const ErrorPage = lazy(() => import('./pages/errorPage/errorPage'));//import errorPage Page
const ConfigurationPage = lazy(() => import('./pages/configurationPage/configurationPage'));//import Configuration Page
const NoAccountPage = lazy(() => import('./pages/noAccountPage/noAccountPage'));//import don't have acc. Page

interface AppProps {
  appClientId: string;
  appEnableErrorLog: string;
  appSupplementaryBaseURL: string;
  appEnableDownloadXLSOption: string;
  appEnableIDPProvider:string;
  appEnableSalesChannel:string;
}
//Routing for App
const App = ({
  appClientId,
  appEnableErrorLog,
  appSupplementaryBaseURL,
  appEnableDownloadXLSOption,
  appEnableIDPProvider,
  appEnableSalesChannel
} : AppProps) => {

  const {setAppData} = useAppContext();
  useEffect(() => {
    if(appClientId !== '') {
      const reqAppData = {
        clientId: appClientId,
        enableErrorLog: appEnableErrorLog,
        supplementaryBaseURL: appSupplementaryBaseURL,
        enableDownloadXLSOption: appEnableDownloadXLSOption,
        isIDPEnabled: appEnableIDPProvider,
        isSalesChannelEnabled: appEnableSalesChannel
      };
      setAppData(reqAppData);
    }
  }, [setAppData, appClientId, appEnableErrorLog, appSupplementaryBaseURL, appEnableDownloadXLSOption, appEnableIDPProvider, appEnableSalesChannel]);

  return (
        <div className={styles.App}>
          <Suspense fallback={<SpinnerComponent/>}>
          {/* Use of Browser router */}
          <BrowserRouter> 
            <Routes>
                <Route path={SHOPIFY_UI_ROUTE}>
                    {/* Route for OnBoarding Page */}
                    <Route path={ONBOARDING_ROUTE} element={ <OnBoarding /> } />
                    {/* Route for Error Page */}
                    <Route path={ERROR_ROUTE} element={ <ErrorPage /> } />
                    {/* Route for Configuration, Tax Settings, MF n FF Page */}
                    <Route path={TAX_CONFIGURATION_ROUTE} element={<ConfigurationPage/>}/>
                    {/* Route for Don't have Vertex Account Page */}
                    <Route path={NO_ACCOUNT_ROUTE} element={<NoAccountPage/>}/>
                </Route>
                {/* Check Route */}
                <Route path="/*" element={<Navigate to={`${SHOPIFY_UI_ROUTE}/`} />}  />
            </Routes>
          </BrowserRouter>
          </Suspense>
        </div>
  );
};
export default App;
